import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Breadcrumb } from "../../../molecules/Breadcrumb";
import { titles } from "../../../constants/titles";
import {
  BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE,
  bulkUpsertStudents,
  Context,
  fetchNextClasses,
  nextYearStudentsPath,
  clearSuccessMessage,
  clearErrorMessage,
  exchangeSchoolYearPath,
  FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
} from "../../../managerStore";
import { BulkStudentForm } from "../../../templates/manager/BulkStudentForm";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useCurrentYear from "../../../hooks/manager/useCurrentYear";
import { IStudentForRegister } from "../../../state";

export const BulkRegisterNextYearStudents = () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const { nextYear } = useCurrentYear();
  const [fetched, setFetched] = React.useState({
    next_classes: false,
  });
  const history = useHistory();
  const bulkRegisterStudentsFunc = useCallback(
    (students: IStudentForRegister[]) => {
      dispatch(peep(bulkUpsertStudents(students)));
    },
    [dispatch, peep],
  );

  useEffect(() => {
    if (state.success_message === FETCH_NEXT_CLASSES_SUCCESS_MESSAGE) {
      setTimeout(() => {
        setFetched(s => ({ ...s, next_classes: true }));
      }, 100);
    }
    if (state.success_message === BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(nextYearStudentsPath);
    }
  }, [history, dispatch, state.success_message]);

  useEffect(() => {
    dispatch(fetchNextClasses(nextYear));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, nextYear]);

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.exchangeSchoolYear, to: exchangeSchoolYearPath },
        ]}
        currentTitle={`${titles.bulkRegisterNextYearStudents} (${nextYear}年度)`}
      />
      {fetched.next_classes && (
        <BulkStudentForm
          title={`${titles.bulkRegisterNextYearStudents} (${nextYear}年度)`}
          error={state.error}
          next_classes={state.next_classes}
          isNextYear={true}
          save={bulkRegisterStudentsFunc}
          calling={calling}
          school={state.manager.school!}
        />
      )}
    </div>
  );
};

export default BulkRegisterNextYearStudents;
